import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';

class AddPartTimeEmployee extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:'',
      form_emp_id:0,
      button_titlte:'Submit',
    };
  }

componentDidMount(){
  var emp_id  = this.props.emp_id;
  var email   = this.props.email;
  var submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_employee_info.bind(this)}>{this.state.button_titlte}</button>;
  this.setState({submit_button});
  if(emp_id>0 && email!=''){
    this.edit_employee_info();
  }
}
edit_employee_info(){
  var button_titlte     = 'Update';
  this.setState({button_titlte});
  var submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_employee_info.bind(this)}>{button_titlte}</button>;
  this.setState({submit_button});
  var form_emp_id  = this.props.emp_id;
  this.setState({form_emp_id});
  var first_name    = this.props.first_name;
  var last_name     = this.props.last_name;
  var user_email    = this.props.email;
  var mobile_number = this.props.mobile_no;
  var user_type     = this.props.emp_type;
  $('#first_name').val(first_name);
  $('#last_name').val(last_name);
  $('#user_email').val(user_email).attr("readonly", "readonly");
  $('#mobile_number').val(mobile_number);
  $('#user_type').val(user_type);
}

add_employee_info(){
  var cutThis           = this;
  var form_emp_id       = cutThis.state.form_emp_id;
  var first_name        = window.isNullAndUndef($('#first_name').val());
  var last_name         = window.isNullAndUndef($('#last_name').val());
  var user_email        = window.isNullAndUndef($('#user_email').val());
  var mobile_number     = window.isNullAndUndef($('#mobile_number').val());
  var user_type         = window.isNullAndUndef($('#user_type').val());
  var web_token         = window.isNullAndUndef($('#web_token').val());
  var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">{cutThis.state.button_titlte}</button>;
  cutThis.setState({submit_button});
  $('label').removeClass('color_red');
  if(first_name && last_name && user_email && mobile_number && user_type && web_token){
    var body = new FormData();
    body.append('first_name',first_name);
    body.append('last_name',last_name);
    body.append('email',user_email);
    body.append('mobile_no',mobile_number);
    body.append('user_type',user_type);
    body.append('web_token',web_token);
    body.append('emp_id',form_emp_id);
    body.append('function','add_emp_info_data');
    var url      = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_part_time_employee_management_url.php";
    }else{
      url = "/php/admin_part_time_employee_management_url.php";
    }
    axios({
         method: 'POST',
         url: url,
         data: body
     })
     .then(function (res) {
        var data = res.data;
        if(data['error']>0){
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.props.close_popup_view}>Close</button>;
        }else{
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_employee_info.bind(cutThis)}>{cutThis.state.button_titlte}</button>;
        }
        cutThis.setState({submit_button});
     })
     .catch(function (error) {
         console.log(error);
     });
  }else{
    window.change_lable_color('first_name','last_name','user_email','mobile_number','user_type');
    submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_employee_info.bind(cutThis)}>{cutThis.state.button_titlte}</button>;
    cutThis.setState({submit_button});
  }
}


  render() {
    return (
        <>
        <div className="modal fade" id="myModal" role="dialog">
          <div className="modal-dialog popup_view_width">
            <div className="modal-content">
              <div className="modal-header">
              <h4 className="modal-title" id="page_titlte">{this.props.page_titlte}</h4>
                <button type="button" className="close" data-dismiss="modal" onClick={this.props.close_popup_view}>&times;</button>
              </div>
              <div className="modal-body">


              <div className="">
              <div className="col-md-12">
                  <div className="wow fadeInUp" data-wow-delay="0.5s">
                      <form action="" method="post">
                          <div className="row g-3">

                              <div className="col-md-4">
                                  <div className="form-floating">
                                      <input type="text" className="form-control" id="first_name" placeholder="First Name"/>
                                      <label for="name">First Name</label>
                                  </div>
                              </div>
                              <div className="col-md-4">
                                  <div className="form-floating">
                                      <input type="text" className="form-control" id="last_name" placeholder="Last Name"/>
                                      <label for="name">Last Name</label>
                                  </div>
                              </div>
                              <div className="col-md-4">
                                  <div className="form-floating">
                                      <input type="text" className="form-control" id="user_email" placeholder="Your Email"/>
                                      <label for="name">Email</label>
                                  </div>
                              </div>
                              <div className="col-md-4">
                                  <div className="form-floating">
                                      <input type="text" className="form-control" id="mobile_number" placeholder="Your Email"/>
                                      <label for="name">Mobile Number</label>
                                  </div>
                              </div>
                              <div className="col-md-4">
                                  <div className="form-floating">
                                      <input type="text" className="form-control" id="user_type" placeholder="User Role"/>
                                      <label for="name">User Role</label>
                                  </div>
                              </div>
                              
                              <div className="col-md-12">
                              <div className="col-md-8">
                                <p id="error_msg"></p>
                              </div>
                                <div className="col-md-4 p-0 float_r">
                                    {this.state.submit_button}
                                </div>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
              </div>


              </div>
            </div>
          </div>
        </div>


        </>
    );
  }
}

export default AddPartTimeEmployee;
